/* eslint-disable default-param-last */
export const types = {
  SEND_RETARGETING: 'RETARGETING/SEND_RETARGETING',
};

export const actions = {
  sendRetargeting: (data) => ({
    type: types.SEND_RETARGETING,
    payload: { data },
  }),
};
